import React from "react";
import './keynoteCard.css';

function KeynoteCard({name, photo, institute}) {
    return (
        <div style={{minWidth: '30%'}}>
            <img className="keynoteImg" src={require(`../keynotes/photos/`+photo)} />
            <h2 className="teamTitle" style={{textAlign: 'center'}}>{name}</h2>
            <h3 className="teamPost" style={{textAlign: 'center', fontWeight: 600}}>{institute}</h3>
        </div>
    )
}

export default KeynoteCard;